"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M12.18 12c0-1.604.887-2.813 2.063-2.813 1.18 0 2.069 1.21 2.069 2.813s-.883 2.812-2.063 2.812S12.18 13.602 12.18 12m.939 0c0 1.033.507 1.874 1.131 1.874.632 0 1.125-.825 1.125-1.875 0-1.033-.507-1.875-1.131-1.875-.632 0-1.125.825-1.125 1.875M8.257 9.717a1.87 1.87 0 0 0 1.2 3.209L8.7 14.088a.469.469 0 0 0 .786.511l1.596-2.444.003-.007a1.86 1.86 0 0 0-.198-2.413 1.88 1.88 0 0 0-1.325-.55l-.002.002c-.487 0-.954.19-1.303.53m.524.824a.938.938 0 1 1 1.559 1.042.938.938 0 0 1-1.56-1.042"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16m7-8a7 7 0 1 1-14 0 7 7 0 0 1 14 0"
  })]
}), 'Days');
//# sourceMappingURL=index.js.map